import React from "react"
import Sample from "../models/sample"
import SampleWaveform from "./SampleWaveform"
import { observer, Provider } from "mobx-react"
import sampleStore from "../stores/sampleStore"

const stores = {
  sampleStore,
}

@observer
export default class SampleWaveformContainer extends React.Component {
  static defaultProps = {
    canPlayMultipleSamplesAtOnce: false,
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { sample, displayTitle, canPlayMultipleSamplesAtOnce } = this.props

    return (
      <Provider {...stores}>
        <SampleWaveform displayTitle={displayTitle} sample={new Sample(sample)} canPlayMultipleSamplesAtOnce={canPlayMultipleSamplesAtOnce} />
      </Provider>
    )
  }
}
